const buildPath = (pattern: string, pathParams?: Record<string, unknown>) => {
  if (!pathParams) return pattern;

  return Object.entries(pathParams).reduce(
    (path, [key, value]) => path.replace(`:${key}`, `${value}`),
    pattern
  );
};

const buildQuery = (queryParams?: Record<string, unknown>) => {
  if (!queryParams) return '';

  const query = Object.entries(queryParams)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

  return query ? `?${query}` : '';
};

const buildUrl = (
  pattern: string,
  {
    pathParams,
    queryParams,
    host = ''
  }: {
    pathParams?: Record<string, unknown>;
    queryParams?: Record<string, unknown>;
    host?: string;
  } = {}
) => {
  const path = buildPath(pattern, pathParams);
  const query = buildQuery(queryParams);

  return `${host}${path}${query}`;
};

export default buildUrl;
